module.exports = __webpack_public_path__ + "static/images/copy.80213bd2973751c7f404b645c9231c46.svg";